<template>
  <div class="linkGroup_box">
    <div>
      <el-dialog
        title="通话"
        width="360px"
        :visible.sync="dialogFormVisible"
        :show-close="false"
        :append-to-body="true"
        :close-on-click-modal="false"
      >
        <span style="padding-top: 10px; padding-left: 10px">{{ CallMsg }}</span>
        <div slot="footer" class="dialog-footer">
          <canvas
            id="videoWin"
            width="320px"
            height="240px"
            hidden
            style="margin: -30px 0px 0px -16px"
          ></canvas>
          <el-button @click="hangupVideo">挂断</el-button>
          <el-button v-if="isShowAnswerButton == true" @click="isAnswer = true"
            >接听</el-button
          >
        </div>
      </el-dialog>
    </div>
    <audio
      id="audio"
      controls="controls"
      hidden
      loop
      src="/lib/audio/call.mp3"
      ref="audio"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import WebSocketApi from "../../websoket/intercomWebsocket";
import MyApis from "../../api/src/alarm.js";
import { saveMsg } from "../../request/msgApi";

export default {
  name: "Communicate",
  data() {
    return {
      dialogFormVisible: false,
      activeGroup: 0,
      filterText: "",
      tabPosition: "left",
      ckeckAllNum: [1, 2, 3, 4],
      checkAll: false,
      isIndeterminate: true,
      activeInd: "0",
      GroupDataTimer: "",
      GroupTimerCount: 0,
      GetPttGroupTimer: "",
      GetPttGroupTimerCount: 0,
      GetPttGroupMembersListTimer: "",
      GetPttGroupMembersListTimerCount: 0,
      CallDataTimer: "",
      InitTimer: "",
      calldata: undefined,
      groupList: [],
      showGroup: [],
      isShowAnswerButton: false,
      isUseFilter: false,
      TemporaryCall: [
        {
          checkAll: true,
          id: "",
          name: "山顶SOS",
          children: [{ name: "山顶SOS", id: "allli", isChecked: true }],
          checkedAllArr: [],
          isShow: true,
          isTemporary: true /*是否临时行程的组*/,
          indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
        },
      ],
      istogroup: false,
      isAnswer: false,
      deptArray: [] /*用户部门列表*/,
      userStateArray: [] /*用户状态列表*/,
      //声明一个变量来注册监听事件
      getSocketData: null,
      pttGroupArray: [] /*对讲组列表*/,
      pttGroupMembersArray: [] /*对讲组成员列表*/,
      sosArray: [] /*sos成员列表*/,
      tempCallData: {},
      isCalling: false,
    };
  },
  props: {
    CallMsg: { type: String, default: "等待回铃" },
    groupArray: { type: Array, default: [] },
  },
  computed: {
    ...mapGetters(["getConnect"]),
    filterInp: function (val) {
      let data = this.groupList;
      data.forEach((item) => {
        return item.children.filter(function (number) {
          console.log(number);
        });
      });
    } /* ...mapState({ 'getConnect':state => state.connectInfo }),*/,
  },
  watch: {
    activeInd: function (val) {
      /*console.log(val)*/
    },
    getConnect: function (val) {
      /*console.log(val)*/
      if (val) {
        this.groupList = this.groupList.push(this.TemporaryCall);
        /*console.log(this.groupList)*/
      }
    },
    dialogFormVisible: function (val) {
      /*console.log("dialogFormVisible",val);*/
      if (val == false) {
        this.HangUp();

        this.saveCallMsg();
      } else {
        this.isCalling = false;
      }
    },
    isAnswer: function (val) {
      /*console.log("isAnswer",val);*/
      if (val) {
        this.isShowAnswerButton = false;
        this.Answer();
        this.isAnswer = false;
      }
    },
    filterText(val) {
      let data = this.groupList;
      let newArr = [];
      if (val) {
        data.forEach((item) => {
          let result = item.children.filter(function (number) {
            /*console.log(number)*/ return number.name.indexOf(val) > -1;
          });
          if (result.length > 0) {
            let obj = {
              checkAll: item.checkAll,
              name: item.name,
              children: result,
              checkedAllArr: item.checkedAllArr,
            };
            newArr.push(obj);
          }
        });
        /*console.log(newArr)*/
        this.groupList = newArr;
        this.isUseFilter = true;
        this.activeInd = "0";
      } else {
        this.groupList = this.showGroup;
        this.isUseFilter = false;
        this.activeInd = "0";
      }
    },
    groupArray(val) {
      if (val && val.length > 0) {
        this.groupList = val;
      }
    },
  },
  created() {
    /*this.groupList = this.showGroup;*/
    if (this.groupArray && this.groupArray.length > 0) {
      this.groupList = this.groupArray;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.InitCanvas();
    });
    /*时间处理*/
    // this.InitTimer = setInterval(this.InitConnect, 1000);
    this.getSocketMessage();
  },
  methods: {
    getSocketMessage() {
      // 创建接收消息函数
      this.getSocketData = (e) => {
        let msgdat = e && e.detail.data;
        //这边编写处理服务端消息代码
        if (msgdat) {
          /*获取所有用户组*/
          if (msgdat.indexOf("SubscriberGroups") != -1) {
            console.log("获取所有用户组成功");
            var myobj = JSON.parse(msgdat);
            const subscriberGroupsArray = myobj.SubscriberGroups;
            this.deptArray = [];
            this.sosArray = [];
            var matchReg = /SOS.*?/gi;

            for (var i = 0; i < subscriberGroupsArray.length; i++) {
              var strText = "";
              var obj = subscriberGroupsArray[i];
              var dept = {};
              dept.GroupName = obj.GroupName;
              dept.GroupMembers = obj.GroupMembers;
              dept.ParentGroup = "";
              this.deptArray.push(dept);
              this.getChildGroups(obj);
              this.GetGroupData();
            }
          }
          /*获取所有对讲组*/
          if (msgdat.indexOf("GetPttGroupList") != -1) {
            //console.log("获取所有对讲组成功");
            var myobj = JSON.parse(msgdat);
            this.pttGroupArray = myobj.GetPttGroupList;
            this.GetPttGroup();
          }
          /*获取某个对讲组的成员*/
          if (msgdat.indexOf("GetPttGroupMembersList") != -1) {
            //console.log("获取某个对讲组的成员");
            var myobj = JSON.parse(msgdat);
            this.pttGroupMembersArray = myobj.GetPttGroupMembersList;
            this.GetPttGroupMembersList();
          }

          var arrInfo = msgdat.split(":");

          if (arrInfo.length == 2) {
            if (arrInfo[0] == "OnStartVideoPlayer") {
              this.GetMakeCallData();
            } else if (arrInfo[0] == "OnPhoneLineState") {
              this.GetMakeCallData();
            }
          }
        }
      };
      this.getStatusChanged = (e) => {
        let msgdat = e && e.detail.data;
        var myobj = JSON.parse(msgdat);

        this.subscriberStatusChanged(myobj.OnSubscriberStatusChanged);
      };
      //注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
      //注册监听事件
      window.addEventListener(
        "OnSubscriberStatusChanged",
        this.getStatusChanged
      );
    },
    InitCanvas() {
      var canvas = document.getElementById("videoWin");
      var context =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      context.clearColor(0, 0, 0, 1);
      context.clear(context.COLOR_BUFFER_BIT);
    },
    GetGroupData() {
      /*获取用户组*/
      let that = this;
      // if (this.GroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对用户组信息超时" });
      //   this.GroupTimerCount = 0;
      //   //console.log("获取对用户组信息超时");
      //   clearInterval(this.GroupDataTimer);
      //   return;
      // }
      // let subscribersgroupsArray = WebSocketApi.GetAllSubscriberGroups();
      let subscribersgroupsArray = this.deptArray;
      if (
        subscribersgroupsArray != undefined &&
        subscribersgroupsArray.length > 0
      ) {
        this.showGroup = [];
        subscribersgroupsArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.GroupName,
            name: item.GroupName,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          var members = item.GroupMembers.split(",");
          if (members != undefined && members.length > 0) {
            members.forEach((mitem) => {
              let childitem = {
                name: WebSocketApi.GetUserNameByNum(mitem),
                id: mitem,
                isChecked: false,
              };
              GroupItem.children.push(childitem);
            });
          }
          this.showGroup.push(GroupItem);
        });
        /*console.log("showGroup",this.showGroup);*/
        this.groupList = this.showGroup;
        this.GroupTimerCount = 0;
        // clearInterval(this.GroupDataTimer);
      }
      this.groupList = this.showGroup;
    },
    GetPttGroup() {
      /*获取对讲组*/
      let that = this;
      // if (this.GetPttGroupTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取对讲机组信息超时" });
      //   //console.log("获取对讲机组信息超时");
      //   this.GetPttGroupTimerCount = 0;
      //   clearInterval(this.GetPttGroupTimer);
      //   return;
      // }
      //let PttGroupArray = WebSocketApi.GetPttGroupList();
      if (this.PttGroupArray != undefined && this.PttGroupArray.length > 0) {
        /*console.log("PttGroupArray",PttGroupArray);*/
        this.PttGroupArray.forEach((item) => {
          let GroupItem = {
            checkAll: false,
            id: item.Number,
            name: item.Name,
            children: [],
            checkedAllArr: [],
            isShow: true,
            isTemporary: false /*是否临时行程的组*/,
            indeterminate: false /* 属性用以表示 checkbox 的不确定状态，一般用于实现全选的效果*/,
          };
          this.showGroup.push(GroupItem);
          //console.log("对讲机通讯", "获取所有对讲组成员" + item.Number);
          WebSocketApi.SendGetPttGroupMembersList(item.Number);
          // this.GetPttGroupMembersListTimer = setInterval(
          //   this.GetPttGroupMembersList,
          //   5000
          // );
          /*获取某个对讲组的成员*/
        });
        // this.GetPttGroupTimerCount = 0;
        // clearInterval(this.GetPttGroupTimer);
      }
    },
    GetPttGroupMembersList() {
      let that = this;
      // if (this.GetPttGroupMembersListTimerCount++ > 50) {
      //   that.$message({ type: "error", message: "获取某个对讲组的成员超时" });
      //   this.GetPttGroupMembersListTimerCount = 0;
      //   clearInterval(this.GetPttGroupMembersListTimer);
      //   return;
      // }
      //let pttGroupMembers = WebSocketApi.GetPttGroupMembersList();
      if (this.pttGroupMembersArray != undefined) {
        this.showGroup.forEach((item) => {
          if (item.id == this.pttGroupMembersArray.PttGroupNumber) {
            var members = this.pttGroupMembersArray.Members.split(",");
            if (members != undefined && members.length > 0) {
              members.forEach((mitem) => {
                let childitem = {
                  name: WebSocketApi.GetUserNameByNum(mitem),
                  id: mitem,
                  isChecked: false,
                };
                item.children.push(childitem);
              });
            }
          }
        });
        /*console.log("pttGroupMembers",pttGroupMembers);*/
        // this.GetPttGroupMembersListTimerCount = 0;
        // clearInterval(this.GetPttGroupMembersListTimer);
      }
    },

    addVoiceClass() {
      $("#voice").addClass("flash animated infinite");
    },
    removeVoiceClass() {
      $("#voice").removeClass("flash animated infinite");
    },
    addVideoClass() {
      $("#video").addClass("flash animated infinite");
    },
    removeVideoClass() {
      $("#video").removeClass("flash animated infinite");
    },
    newVoiceTalk() {
      let data = this.groupList;
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          newChildren.push(item.children);
          item.children.forEach((child) => {
            childNums += child.id + ",";
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (newChildren.length > 1) {
        this.$message({
          message: "只能选择一位人员进行语音通话",
          type: "error",
        });
        return;
      }
      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        this.MakeCall(childNums);
        this.addVoiceClass();
      }
    },
    newVideoTalk() {
      let data = this.groupList;
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          newChildren.push(item.children);
          item.children.forEach((child) => {
            childNums += child.id + ",";
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (newChildren.length > 1) {
        this.$message({
          message: "只能选择一位人员进行视频通话",
          type: "error",
        });
        return;
      }
      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        this.MakeVideoCall(childNums);
        this.addVideoClass();
        $("#videoWin").show();
      }
    },
    newTalk() {
      let data = this.groupList;
      //console.log("选中的用户", data)
      let newChildren = [];
      let childNums = "";
      data.forEach((item) => {
        if (item.checkAll) {
          newChildren.push(item.children);
          item.children.forEach((child) => {
            childNums += child.id + ",";
          });
        } else {
          if (item.indeterminate) {
            let childData = item.children;
            childData.forEach((child) => {
              if (child.isChecked) {
                newChildren.push(child);
                childNums += child.id + ",";
              }
            });
          }
        }
      });
      /* console.log(newChildren)*/
      if (newChildren.length == 0) {
        this.$message({ message: "您还没选中人员", type: "error" });
        return;
      }
      if (childNums.length > 0) {
        childNums = childNums.substr(0, childNums.length - 1);
        this.Conference(childNums);
        this.addVoiceClass();
      }
    },
    MakeCall(id) {
      this.CallMsg = "等待" + id + "接听";
      this.dialogFormVisible = true;
      console.log("呼叫", id);
      WebSocketApi.MakeCall(id);
    },
    MakeVideoCall(id) {
      this.CallMsg = "等待" + id + "接听";
      this.dialogFormVisible = true;
      console.log("视频呼叫", id);
      WebSocketApi.MakeVideoCall(id);
    },
    GetMakeCallData() {
      this.calldata = WebSocketApi.GetCallData();
      console.log("线路状态", this.calldata.CurrentLineState);

      if (this.calldata != undefined && this.calldata.strText != "") {
        if (this.calldata.confInfo) {
          this.CallMsg = this.calldata.confInfo;
        } else {
          this.CallMsg = this.calldata.strText;
        }

        this.dialogFormVisible = true;
      }
      if (this.calldata.CurrentLineState == "等待回铃") {
        //this.dialogFormVisible = true;
      }

      if (this.calldata.CurrentLineState == "振铃") {
        this.isShowAnswerButton = true;
        this.dialogFormVisible = true;
        this.playMusic();
      }
      if (this.calldata.CurrentLineState == "空闲") {
        this.dialogFormVisible = false;
        this.stopMusic();
      }
      if (this.calldata.CurrentLineState == "通话") {
        this.dialogFormVisible = true;
        this.isShowAnswerButton = false;
        if (this.calldata.isVideoCall) {
          this.addVideoClass();
          $("#videoWin").show();
        }
        this.isCalling = true;
        this.stopMusic();
      }
    },
    HangUp() {
      console.log("挂断");
      WebSocketApi.HangUp();
      this.dialogFormVisible = false;
      this.removeVoiceClass();
      this.removeVideoClass();
      $("#videoWin").hide();
    },
    hangupVideo() {
      this.dialogFormVisible = false;
      this.removeVideoClass();
    },

    Answer() {
      console.log("接听");
      WebSocketApi.Answer();
      this.addVoiceClass();
    },
    Conference(Nums) {
      this.dialogFormVisible = true;
      console.info(WebSocketApi.getLoginUser());
      this.CallMsg = "临时会议: " + WebSocketApi.getLoginUser() + " => " + Nums;
      console.log("临时会议", Nums);
      WebSocketApi.Conference(Nums);
    },
    /*获取用户组下的子组*/
    getChildGroups(parentGrp) {
      var matchReg = /SOS.*?/gi;
      var childs = parentGrp.GroupChilds;
      if (typeof childs != "undefined") {
        for (var i = 0; i < childs.length; i++) {
          var obj = childs[i];
          var dept = {};
          dept.GroupName = obj.GroupName;
          dept.GroupMembers = obj.GroupMembers;
          dept.ParentGroup = parentGrp.GroupName;
          this.deptArray.push(dept);
          if (obj.GroupName.match(matchReg)) {
            let members = obj.GroupMembers.split(",");
            this.sosArray = this.sosArray.concat(members);
          }
          this.getChildGroups(obj);
        }
      }
    },

    /*监听用户状态，增加sos报警及呼叫记录*/
    subscriberStatusChanged(value) {
      //呼叫号码有值
      if (value && value.Number && value.OppNumber) {
        //呼叫
        if (value.Status === 3) {
          //判断是否是sos呼叫指挥中心1000
          if (this.numIsSos(value.Number, value.OppNumber)) {
            this.addSosAlarmInfo(value.Number, value.OppNumber);
            this.saveMsg(
              "sos",
              "0",
              value.Number,
              "指挥中心",
              "10000005",
              "SOS呼叫",
              "0"
            );
          }
          // this.saveMsg("call", "", value.Number, value.OppNumber);
          //记录本机1020的呼叫记录
          if (
            value.Number == global.$config.api.strNumber ||
            value.OppNumber == global.$config.api.strNumber
          ) {
            this.tempCallData = {
              Number: value.Number,
              OppNumber: value.OppNumber,
            };
          }
        }
        // if (
        //   (value.Number == global.$config.api.strNumber ||
        //     value.OppNumber == global.$config.api.strNumber) &&
        //   value.Status === 4
        // ) {
        //   this.saveMsg("call", "已接通", value.Number, value.OppNumber);
        // }
      }
    },
    numIsSos(callNumber, oppNumber) {
      // return true;
      //不是打给1000的，并且不是sos用户，则不是一键报警
      if (oppNumber == 1000 && this.sosArray.indexOf(callNumber) > -1) {
        return true;
      } else {
        return false;
      }
    },
    //添加报警弹窗
    addSosAlarmInfo(callNumber, oppNumber) {
      let obj = {
        AlertType: "24",
        AlerteLevel: 10,
        Content:
          "调度成员" +
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber) +
          "呼叫指挥中心",

        Source: 3,
        Creater: "数据预警服务",
        Modifier: "数据预警服务",
        Location: "天山天池",
        Contact: WebSocketApi.GetUserNameByNum(callNumber) || callNumber,
        Phone: callNumber,
        SourceDesc:
          "【调度系统】" +
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber),
        TargetType: "12",
        TargetId: ZJApp.ZJUtils.uuid(),
        AlertDate: new Date(),
        CreateTime: new Date(),
        ModifyTime: new Date(),
      };
      new MyApis()
        .SendDetail(obj)
        .then((r) => {
          console.log("报警成功");
        })
        .catch((e) => {
          console.log(e);
          // this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveMsg(
      messageType,
      status,
      callNumber,
      oppNumber,
      kind,
      categoryName,
      isRead
    ) {
      let params = {
        creater: ZJApp.ZJUser.current.UserName,
        modifier: ZJApp.ZJUser.current.UserName,
        messageType: messageType,
        messageTypeName: "呼叫",
        dataTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        address: "天山天池",
        longitude: 88.13808,
        latitude: 43.89902,
        content:
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber) +
          "呼叫" +
          (WebSocketApi.GetUserNameByNum(oppNumber) || oppNumber),
        status: status,
        category: kind,
        // kind: kind,
        categoryName: categoryName,
        // level: level,
        // type: "emergency_event", // 类型(0人工处理，1、转任务， 2、转应急)
        videos: "",
        audios: "",
        images: "",
        sourceId: null, //关联任务id，非必传
        sourceName:
          "【调度系统】" +
          (WebSocketApi.GetUserNameByNum(callNumber) || callNumber),
        isRead: isRead, //0-未读，1-已读
      };
      saveMsg(params).then((res) => {
        console.log("人工处理预警结果");
        console.log(res);
      });
    },
    saveCallMsg() {
      if (
        this.tempCallData &&
        this.tempCallData.Number &&
        this.tempCallData.OppNumber &&
        this.tempCallData.Number != this.tempCallData.OppNumber
      ) {
        if (this.isCalling) {
          this.saveMsg(
            "call",
            "20",
            this.tempCallData.Number,
            this.tempCallData.OppNumber,
            "10000006",
            "用户呼叫",
            "1"
          );
          this.tempCallData = {};
        } else {
          this.saveMsg(
            "call",
            "10",
            this.tempCallData.Number,
            this.tempCallData.OppNumber,
            "10000006",
            "用户呼叫",
            "0"
          );
          this.tempCallData = {};
        }
      }
    },
    playMusic() {
      this.$nextTick(() => {
        //  this.$refs.audio.src = require("/audio/alarm.mp3");

        this.$refs.audio.currentTime = 0; //从头开始播放提示音
        this.$refs.audio.play(); //播放
      });
    },
    stopMusic() {
      this.$refs.audio.pause(); //停止播放
    },
  },
  destroyed() {
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
    window.removeEventListener(
      "OnSubscriberStatusChanged",
      this.getStatusChanged
    );
  },
};
</script>
<style lang="scss" scoped>
</style>